import { InviteStatus } from '~/client/graph'

import User from '../models/User'
import UserProjectsStore from '../stores/domain/UserProjects.store'

export default function canApproveUser(
  user: User,
  userProjectsStore: UserProjectsStore,
) {
  const userProject = userProjectsStore?.getByUser(user)

  return (
    userProject?.inviteStatus === InviteStatus.NotInvited &&
    user.isSignUpCreated &&
    user.setUpFinished === null
  )
}
